import apiClient from './axios.config';

export interface Checklist {
    id: number;
    name: string;
    status: 'pending' | 'passed' | 'failed' | 'in-progress' | 'acceptable';
    alertStatus?: 'low' | 'medium' | 'high' | 'critical' | 'sent' | 'failed' | 'pending';
    inspectionId: number;
    faultPhotosUrls?: string[];
    photoUrls?: string[];
    remark?: string;
    analyzedAt?: string;
    createdAt: string;
    updatedAt: string;
}

export interface UpdateChecklistStatusResponse {
    checklist: Checklist;
    inspectionCompleted: boolean;
}

class ChecklistService {
    async getChecklistsByInspection(inspectionId: number): Promise<Checklist[]> {
        try {
            const response = await apiClient.get(`/checklist/inspection/${inspectionId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching checklists by inspection:', error);
            throw error;
        }
    }

    async updateChecklistStatus(checklistId: number, status: 'passed' | 'failed' | 'acceptable'): Promise<UpdateChecklistStatusResponse> {
        try {
            const response = await apiClient.put(`/checklist/${checklistId}/status`, {
                status
            });
            return response.data;
        } catch (error) {
            console.error('Error updating checklist status:', error);
            throw error;
        }
    }
}

export const checklistService = new ChecklistService();
export default checklistService; 